// #3234: chi entra da un sito con cui non ha ancora un rapporto (un cliente
// Newarc che accede su immaginacasa.com, o viceversa) lo ottiene dal server:
// ensureMyWebClientCard (newarc-cloud-functions) aggiunge alla scheda esistente
// il rapporto con l'azienda del brand del sito. Solo per le schede web-client:
// `companies` lo scrive soltanto il server.
export function needsCompanyLink(cardData, brand) {
  if (!cardData || cardData.type !== "web-client") return false;
  const companies = Array.isArray(cardData.companies) ? cardData.companies : [];
  return !companies.includes(brand);
}
